import React, { useState } from "react";
import { Box, Flex, Icon, Tab, TabList, Tabs, Text, useColorModeValue } from "@chakra-ui/react";
import { MdPayments } from "react-icons/md";
import PaymentsConfigPanel from "./PaymentsConfigPanel";
import RefundsPendingPanel from "./RefundsPendingPanel";
import ManualActionsPanel from "./ManualActionsPanel";
import PaymentsBrowsePanel from "./PaymentsBrowsePanel";
import { PAYMENTS_TAB_IDS } from "./paymentsConstants";

const PAYMENT_TABS = [
    { id: PAYMENTS_TAB_IDS.config, label: "Configuration" },
    { id: PAYMENTS_TAB_IDS.refunds, label: "Remboursements bloqués" },
    { id: PAYMENTS_TAB_IDS.manual, label: "Actions manuelles" },
    { id: PAYMENTS_TAB_IDS.browse, label: "Paiements" },
];

/**
 * Renders the page header with a brand icon badge, title and intro text.
 * @returns {React.ReactElement}
 */
function PageHeader() {
    const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Flex align="center" gap="12px" mb="20px">
            <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg} flexShrink="0">
                <Icon as={MdPayments} w="24px" h="24px" color="brand.500" />
            </Flex>
            <Box>
                <Text fontSize="lg" fontWeight="700" color={titleColor}>Paiements &amp; Remboursements</Text>
                <Text fontSize="sm" color={subColor}>
                    Gestion de la configuration des paiements, des remboursements bloqués (Stripe et Orange Money) et des actions manuelles
                </Text>
            </Box>
        </Flex>
    );
}

/**
 * Renders the active panel based on the selected tab id.
 * @param {Object} props - Body props
 * @param {string} props.activeTab - Selected tab id
 * @returns {React.ReactElement}
 */
function ActivePanel({ activeTab }) {
    if (activeTab === PAYMENTS_TAB_IDS.config) return <PaymentsConfigPanel />;
    if (activeTab === PAYMENTS_TAB_IDS.refunds) return <RefundsPendingPanel />;
    if (activeTab === PAYMENTS_TAB_IDS.manual) return <ManualActionsPanel />;
    if (activeTab === PAYMENTS_TAB_IDS.browse) return <PaymentsBrowsePanel />;
    return null;
}

/**
 * Top-level admin view for payments management.
 * Four tabs: Configuration / Remboursements / Actions manuelles / Paiements.
 * @returns {React.ReactElement}
 */
function Payments() {
    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <Box>
            <PageHeader />
            <Tabs index={activeIndex} onChange={setActiveIndex} colorScheme="brand" mb="20px">
                <TabList>
                    {PAYMENT_TABS.map((t) => <Tab key={t.id} fontSize="sm">{t.label}</Tab>)}
                </TabList>
            </Tabs>
            <ActivePanel activeTab={PAYMENT_TABS[activeIndex].id} />
        </Box>
    );
}

export default Payments;
